// extracted by mini-css-extract-plugin
module.exports = {"countdown":"_26X_WQ","horizontal":"_1pTHmx","digits":"_1VOR2y"};